import ivclass from '@invideoio/web-shared/Modules/IVClass';

import TitleH2BlockGradient from '@components/common/Title/TitleH2BlockGradient';
import {
  BrowserType,
  PlatformType,
} from '@invideoio/web-shared/constants/common';
import WorkFlowCard from './MakeWorkFlowCard';

interface WorkflowProps {
  platform: PlatformType;
  browser: BrowserType;
  makeWorkFlow: any;
  isAiPage?: boolean;
}

const WorkflowV2 = (props: WorkflowProps) => {
  const { platform, browser, makeWorkFlow, isAiPage } = props;

  const { title, MakeWorkflowCard } = makeWorkFlow;

  return (
    <section
      className={ivclass(
        'xl:iv-px-20 lg:iv-px-40 md:iv-px-25 sm:iv-px-20',
        'xl:iv-pt-200 iv-pt-150 sm:iv-pt-100',
      )}
    >
      <div
        className={ivclass(
          'xl:iv-pb-75 iv-pb-50 sm:iv-pb-30',
          'xl:iv-pl-40 iv-pl-35 sm:iv-px-5',
          'iv-grid',
        )}
      >
        <TitleH2BlockGradient heading={title} />
      </div>

      {Array.isArray(MakeWorkflowCard) && (
        <div
          className={ivclass('iv-mb-40 sm:iv-mb-20 last-of-type:iv-mb-[0px]')}
        >
          <div
            className={ivclass(
              'iv-grid',
              'iv-gap-40 md:iv-gap-25 sm:iv-gap-25',
              'iv-grid-cols-1',
            )}
          >
            {MakeWorkflowCard.map(card => (
              <WorkFlowCard
                makeWorkFlowCard={card}
                key={card.id}
                browser={browser}
                platform={platform}
                isAiPage={isAiPage}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default WorkflowV2;
